export default [
	{
		category: true,
		title: 'Ajustes',
		auth: {
			type: 'strict',
			roles: ['_BOSS']
		}
	},
	{
		title: 'Usuarios',
		key: '_users',
		icon: 'meh',
		url: { name: '_users' },
		auth: {
			type: 'strict',
			roles: ['_BOSS']
		}
	}
];
